import { isNumber } from 'lodash-es';
import { getUserType } from './session-util';
import * as UserType from '../constants/UserType';
import { IMAGE_PREFIX } from '../constants/constants';
import { formatNumber } from '../utils/format-number-util';
import {
  PERCENTAGE_PRECISION,
  PRICE_PRECISION
} from '../constants/decimal-points';

const serializeAsQueryString = function (obj, ignoreNulls = false) {
  const str = [];
  for (const p in obj)
    if (
      obj.hasOwnProperty(p) &&
      (!ignoreNulls || (obj[p] !== null && obj[p] !== undefined))
    ) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};

const getQueryStringAsObject = () => {
  const url = new URL(window.location);
  const params = url.searchParams;
  return Array.from(params.keys()).reduce(
    (paramObj, key) => ({
      ...paramObj,
      [key]: params.get(key)
    }),
    {}
  );
};

const getQueryStringParam = (key) => getQueryStringAsObject()[key];

const formatAsFloat = (value, scale = PRICE_PRECISION) =>
  isNumber(value) ? formatNumber(value.toString(), scale) : null;

const formatAsFloatString = (value, scale = PRICE_PRECISION) => {
  return isNumber(value) ? formatNumber(value.toString(), scale) : null;
};

const formatAsMoneyString = (value, defaultReturn = null) =>
  isNumber(value)
    ? `$${formatAsFloatString(value, PRICE_PRECISION)}`
    : defaultReturn;

const toPercent = (value, shouldConvert) =>
  shouldConvert
    ? formatNumber((value * 100).toString(), PERCENTAGE_PRECISION)
    : formatNumber(value.toString(), PERCENTAGE_PRECISION);

const formatAsPercentString = (value, shouldConvert = true) =>
  toPercent(value, shouldConvert) + '%';

const dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
const formatDateForDisplay = (value, defaultDisplay) =>
  !!value
    ? new Date(value).toLocaleDateString('en-US', dateOptions)
    : defaultDisplay;

const convertUTCDateToLocalDate = (htmlDate) => {
  const date = new Date(htmlDate);
  const newDate = new Date(
    date.getTime() + date.getTimezoneOffset() * 60 * 1000
  );

  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;
};

const sortByNumberOrString = (a, b) => {
  const isNum = isNumber(a);
  const isFalsey = !a;
  if (isNum) {
    return Number(a) - Number(b);
  }
  if (isFalsey) {
    return -1;
  }
  return a.localeCompare(b);
};

const isStringNumber = (s) => s === '' + Number(s);

const getHomeUrlForUser = () => UserType[getUserType()].homeUrl;

const imageForDisplay = (imageString) =>
  !!imageString ? IMAGE_PREFIX + imageString : '';

const imageForSaving = (imageString) =>
  !!imageString ? imageString.substr(IMAGE_PREFIX.length) : imageString;

const isEmail = (email) =>
  email != null &&
  email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  const isNullOrEmpty = (text) => {
    return text == null || text === '';
  }

export {
  serializeAsQueryString,
  getQueryStringAsObject,
  getQueryStringParam,
  formatAsFloat,
  formatAsFloatString,
  formatAsMoneyString,
  toPercent,
  formatAsPercentString,
  sortByNumberOrString,
  formatDateForDisplay,
  isStringNumber,
  getHomeUrlForUser,
  convertUTCDateToLocalDate,
  imageForDisplay,
  imageForSaving,
  isEmail,
  isNullOrEmpty
};
